module.exports = __webpack_public_path__ + "media/images/icons/flags/lang-de-0ed67ae98fc2352d2b3e3e88eda72c2f.svg";